import React, { useState, useContext } from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Button } from 'syngenta-react-components'
import { useForm } from 'react-hook-form'
import { convertToSentenceCase } from '../../../services/utils'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { AuthContext } from '../../../services/context'

export const CompanyInformation = ({ companyInfo, patchHandler, handleModal, companyID }) => {
  const [toggleForm, setToggleForm] = useState(false)
  const { register, handleSubmit, errors } = useForm()
  const { hasAccess } = useContext(AuthContext)
  let dataArray = []
      
  if(companyInfo){
    dataArray.push(
      companyInfo.inventory_code ? [
        { id: 3, title: 'Address', value: `${companyInfo.address1} ${companyInfo.city}, ${companyInfo.state} ${companyInfo.zipcode}` },
        { id: 4, title: 'Phone', value: companyInfo.formatedPhone },
        { id: 5, title: 'Inventory Code', value: companyInfo.inventory_code }
      ] :
        [
          { id: 3, title: 'Address', value: `${companyInfo.address1} ${companyInfo.city}, ${companyInfo.state} ${companyInfo.zipcode}` },
          { id: 4, title: 'Phone', value: companyInfo.formatedPhone }
        ] 
    )
    if(companyInfo.sap_id && companyInfo.sap_id !== 'N/A'){
      dataArray.unshift([{ id: 2, title: 'SAP Id', value: companyInfo.sap_id }])
    }
  }
  

  const renderCompanyInformation = () => {
    const cardContent = dataArray && dataArray.map((arrayEntry, index) => {
      const mappedArrayEntry = (
        <div key={index}>
          <div className='mt20'>
            {
              arrayEntry.map(entry => {
                let headerFormat = 'tal fz13 c-darkgray fw600'
                return (
                  <div key={entry.id} className='df mb10 tal'>
                    <div>
                      <div className={headerFormat}>
                        {entry.title}
                      </div>
                      <div className='fz15'>
                        {entry.value}
                      </div>
                    </div>
                  </div>)
              })}
          </div>
          {index < (dataArray.length - 1) && <div className='bb1-s-lightgray hide-tablet pt10 mb10' />}
        </div>
      )
      return mappedArrayEntry
    })
    return (
      <div className='df mt10 mb10'>
        <div className='w100%'>
          {cardContent}
        </div>
      </div>
    )
  }

  const onSubmit = dataObj => {
    if (Object.entries(errors).length === 0) {
      let patchArg = {}
      for (let key in dataObj) {
        if (dataObj[key]) {
          patchArg[key] = dataObj[key]
        }
      }
      patchHandler(patchArg)
      setToggleForm(prev => !prev)
    }
  }

  const handleCancel = e => {
    e.preventDefault()
    setToggleForm(prev => !prev)
  }
  let widgetTitle = ''
  let widgetButton = null
  if(companyInfo?.company_type){
    widgetTitle = `${convertToSentenceCase(companyInfo?.company_type)} information`
    const permissions = ['update-company', 'update-assigned-company']
    if(hasAccess(companyID, permissions) === 'SUCCESS'){
      widgetButton = <Button text={`Edit ${convertToSentenceCase(companyInfo?.company_type)}`} clickHandler={handleModal} />
    }
  }

  return (
    <Widget title={widgetTitle} button={widgetButton}>
      {companyInfo ? 
        renderCompanyInformation()
        :
        <TableStatus status='LOADING'/>
      }
      {toggleForm &&
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='mt20 fll'>Address:</div>
      <input type='text' name='address1' placeholder={companyInfo?.address1} ref={register({ minLength: 1 })} />
      <div className='mt20 fll'>City:</div>
      <input type='text' name='city' placeholder={companyInfo?.city} ref={register({ minLength: 1 })} />
      <div className='mt20 fll'>State:</div>
      <input type='text' name='state' placeholder={companyInfo?.state} ref={register({ minLength: 1 })} />
      <div className='mt20 fll'>Zipcode:</div>
      <input type='text' name='zipcode' placeholder={companyInfo?.zipcode} ref={register({ minLength: 1 })} />
      <div className='mt20 fll'>Phone:</div>
      <input type='text' name='phone' placeholder={companyInfo?.phone} ref={register({ minLength: 1 })} />
      <div className='mt20 df'>
        <Button type='success' text='Submit' />
        <div className='ml50'>
          <Button text='Cancel' clickHandler={e => { handleCancel(e) }}></Button>
        </div>
      </div>
    </form>}
    </Widget>
  )
}
export default CompanyInformation